import { render, staticRenderFns } from "./RoundModalTrackingBet.vue?vue&type=template&id=2b8d466a&"
import script from "./RoundModalTrackingBet.vue?vue&type=script&lang=ts&"
export * from "./RoundModalTrackingBet.vue?vue&type=script&lang=ts&"
import style0 from "./RoundModalTrackingBet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports